module.exports = __webpack_public_path__ + "img/morales-dice.34039c06.svg";